import React from "react";
import {
  AuthContainer,
  AuthSideInfo,
  AuthSideForm,
  InfoContainer,
  ICTITLE,
} from "./auth.styled";
import LoginForm from "components/auth/LoginForm";
import { Modal } from "@mui/material";
import { useSelector } from "react-redux";
import ForgotPasswordModal from "components/userProfile/ForgotPasswordModal";
import RegisterForm from "components/auth/RegisterForm";
import EmailConfirmationModal from "components/register/EmailRegisterModal";
import { useTranslation } from "react-i18next";

export default function AuthRegister() {
  const { t } = useTranslation("auth");

  const { viewEmailConfirmModal, viewForgotPasswordModal } = useSelector(
    (state) => state.auth,
  );

  return (
    <AuthContainer>
      <AuthSideInfo>
        <InfoContainer>
          <ICTITLE>{t("portal.aboutTitle")}</ICTITLE>
          <span>{t("portal.aboutBody")}</span>
        </InfoContainer>
      </AuthSideInfo>
      <AuthSideForm>
        <RegisterForm />
      </AuthSideForm>
      <Modal open={viewForgotPasswordModal}>
        <ForgotPasswordModal />
      </Modal>
      <Modal open={viewEmailConfirmModal}>
        <EmailConfirmationModal />
      </Modal>
    </AuthContainer>
  );
}
